import { nullable } from "./index";
import * as t from "io-ts";
export const clientProductPricingAgreementCreateUpdateReqBodyT = t.strict({
    clientId: t.string,
    productId: t.string,
    name: nullable(t.string),
    unitNumber: nullable(t.number),
    unitId: nullable(t.string),
    salesPrice: t.number,
    discountPercentage: nullable(t.number),
});
export const clientProductPricingAgreementT = t.intersection([
    clientProductPricingAgreementCreateUpdateReqBodyT,
    t.strict({
        id: t.string,
    }),
]);
//# sourceMappingURL=client-product-pricing-agreements.js.map